import {
  axiosPutRequest,
  getHealthPictureRoute,
  axiosGetRequest,
  axiosPostRequest,
  axiosDeleteRequest,
} from '../../api';
import { UpdateJournalDto, CreateJournalDto } from './dtos';
import { Journal } from './model';

export const fetchJournalsCall = (healthJourneyId: string) => {
  return axiosGetRequest<Journal[]>(
    `${getHealthPictureRoute()}/journals/${healthJourneyId}`
  );
};
export const deleteJournalCall = (journalId: string) => {
  return axiosDeleteRequest<string, void>(
    `${getHealthPictureRoute()}/journals/${journalId}`
  );
};

export const createJournalCall = (newJournal: CreateJournalDto) => {
  return axiosPostRequest<CreateJournalDto, Journal>(
    `${getHealthPictureRoute()}/journals`,
    newJournal
  );
};

export const updateJournalCall = (journal: UpdateJournalDto) => {
  return axiosPutRequest<UpdateJournalDto, Journal>(
    `${getHealthPictureRoute()}/journals`,
    journal
  );
};
